import { stores } from '@migrate/stores'
import { LocalesStore } from '@migrate/stores/LocalesStore'
import { INumberFormatOptions } from '@migrate/utils/form/NumericRenderer'
import { fromNumber, fromNumberString } from '@migrate/utils/number'

export default function renderNumeric(
  value?: number | string,
  minFractionDigits?: number,
  maxFractionDigits?: number,
  unit?: string,
) {
  const { locale } = stores[LocalesStore.STORE_NAME]
  if (typeof value !== 'undefined' && value !== null && value !== '') {
    if (!isNaN(Number(value))) {
      const options: INumberFormatOptions = {}
      // todo: need to check with business if the locale should be source of truth for numeric or
      // if hardcoding to 2 decimal places if none given is desired
      options.minimumFractionDigits = minFractionDigits !== undefined ? minFractionDigits : 2
      options.maximumFractionDigits = maxFractionDigits !== undefined ? maxFractionDigits : 20
      return (
        fromNumber(
          typeof value === 'string' ? fromNumberString(value).toNumber() : value,
        ).toLocalizedString(options, locale) + (unit ? ' ' + unit : '')
      )
    }
    return value.toString()
  }

  return value || ''
}
